// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"65689d44","535":"d15383e2","812":"24ac3ff4","888":"b03fd1c9","922":"56a434c8","991":"9f5b6925"}[chunkId] + ".chunk.css";
};